import { useEffect, useRef, useState } from "react";
import { GameShell, useGameLoop, beep } from "./_gameKit";

export default function JixxeoStackIt() {
  const canvasRef = useRef(null);
  const [running, setRunning] = useState(true);
  const [tower, setTower] = useState([]); // each: {x, w, color}
  const [score, setScore] = useState(0);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_stack_best") || 0));
  const sliderRef = useRef({ x: 0, dir: 1, w: 90 });
  const towerRef = useRef([]);

  useEffect(() => { towerRef.current = tower; }, [tower]);

  const drop = () => {
    if (!running) return;
    beep(660, 0.08);
    const s = sliderRef.current;
    const cw = canvasRef.current.width;
    const prev = towerRef.current[towerRef.current.length - 1] || { x: cw / 2 - 90, w: 180 };
    const overlapL = Math.max(s.x, prev.x);
    const overlapR = Math.min(s.x + s.w, prev.x + prev.w);
    const ow = overlapR - overlapL;
    if (ow <= 0) { setRunning(false); beep(120, 0.3); return; }
    const color = ["#00F0FF","#39FF14","#FFE300","#FF003C","#8A2BE2"][towerRef.current.length % 5];
    setTower((t) => [...t, { x: overlapL, w: ow, color }]);
    setScore((n) => n + 1);
    sliderRef.current.w = ow;
    sliderRef.current.dir = -sliderRef.current.dir;
  };

  useEffect(() => {
    const kd = (e) => { if (e.code === "Space" || e.key === "Enter") drop(); };
    const click = () => drop();
    window.addEventListener("keydown", kd);
    canvasRef.current && canvasRef.current.addEventListener("pointerdown", click);
    return () => {
      window.removeEventListener("keydown", kd);
      canvasRef.current && canvasRef.current.removeEventListener("pointerdown", click);
    };
    // eslint-disable-next-line
  }, [running]);

  useGameLoop(canvasRef, ({ ctx, w, h, dt }) => {
    ctx.fillStyle = "#050510"; ctx.fillRect(0, 0, w, h);
    // starfield hint
    // Update slider
    const s = sliderRef.current;
    if (running) {
      s.x += s.dir * 240 * dt * (1 + towerRef.current.length * 0.04);
      if (s.x + s.w > w - 10) s.dir = -1;
      if (s.x < 10) s.dir = 1;
    }
    // Draw tower stacked bottom-up
    const blockH = 26;
    const stackedH = towerRef.current.length * blockH;
    const baseY = h - 60;
    towerRef.current.forEach((b, i) => {
      const y = baseY - (i + 1) * blockH;
      ctx.fillStyle = b.color; ctx.shadowColor = b.color; ctx.shadowBlur = 12;
      ctx.fillRect(b.x, y, b.w, blockH - 2);
    });
    ctx.shadowBlur = 0;
    // Draw slider
    const sY = Math.max(80, baseY - stackedH - blockH - 8);
    ctx.fillStyle = running ? "#FFE300" : "#666";
    ctx.shadowColor = "#FFE300"; ctx.shadowBlur = 18;
    ctx.fillRect(s.x, sY, s.w, blockH);
    ctx.shadowBlur = 0;
  }, running);

  useEffect(() => {
    if (!running && score > best) { setBest(score); localStorage.setItem("jixxeo_stack_best", String(score)); }
  }, [running, score, best]);

  const restart = () => {
    sliderRef.current = { x: 0, dir: 1, w: 180 };
    setTower([]); setScore(0); setRunning(true);
  };

  return (
    <GameShell canvasRef={canvasRef} title="Jixxeo Stack It" accent="#FFE300"
      adGame="jixxeo-stack-it"
      chips={[["Height", score], ["Best", best]]}
      instructions="Tap / space to drop · align blocks perfectly"
      gameOver={!running ? { title: "Missed!", subtitle: `${score} floors` } : null}
      onRestart={restart}
    />
  );
}
